export const share_mail = (id) => {
  const box = {
    email: "",
    subject: "Regardez cette annonce",
    content: `Bonjour,%0A%0ARegardez cette annonce vue sur www.foncierpublic.com/bien/${id}%0A%0ABien cordialement.`,
  };
  return `mailto:${box.email}?subject=${box.subject}&body=${box.content}`;
};

export const contact_mail = (id) => {
  const box = {
    email: "contact@foncierpublic.com",
    subject:
      "Je suis intéressé.e par une annonce vue sur www.foncierpublic.com",
    content: `Bonjour,%0A%0AJe suis intéressé.e par cette annonce vue sur www.foncierpublic.com/bien/${id}%0A%0AMerci de prendre contact avec moi en m'écrivant à cette adresse électronique: <indiquez ICI votre mail> ou en me contactant au : <indiquez ICI votre téléphone>%0A%0ABien cordialement.`,
  };
  return `mailto:${box.email}?subject=${box.subject}&body=${box.content}`;
};
